import { render, staticRenderFns } from "./FideicomisoBeneficiarios.vue?vue&type=template&id=cddc8ff0&scoped=true"
import script from "./FideicomisoBeneficiarios.vue?vue&type=script&lang=js"
export * from "./FideicomisoBeneficiarios.vue?vue&type=script&lang=js"
import style0 from "./FideicomisoBeneficiarios.vue?vue&type=style&index=0&id=cddc8ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddc8ff0",
  null
  
)

export default component.exports